export default __webpack_public_path__ + "static/media/07.ddd1c77a.png";